module.exports = __webpack_public_path__ + "static/group5_5-07ed45f251884b8a9d0f1eeb7156432e.webp";